module.exports = __webpack_public_path__ + "img/HZ-B5999.d62495bd.jpg";